<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirm($event)"
  (cancel)="cancel()"
>
  <div class="dialog">
    <div class="spacing--margin-top">
      <div>
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'name' | translate }}</mat-label>

          <input
            matInput
            formControlName="name"
            [placeholder]="'name' | translate"
            data-test="treatment-name"
          />
        </mat-form-field>
      </div>

      <div class="flex--row flex--gutter">
        <div class="flex__child--auto">
          <mat-form-field>
            <mat-label>{{ 'objective' | translate }}</mat-label>

            <mat-select
              formControlName="objective"
              [placeholder]="'objective' | translate"
              data-test="treatment-objective"
            >
              @for (objective of data.objectives; track objective) {
                <mat-option [value]="objective.value">
                  {{ objective.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex__child--auto">
          <mat-form-field>
            <mat-label>{{ 'period' | translate }}</mat-label>

            <mat-select
              formControlName="periodId"
              [placeholder]="'period' | translate"
              data-test="treatment-period-id"
            >
              @for (period of filteredSalesOrderPeriods(data.salesOrderPeriods); track period) {
                <mat-option [value]="period.id">
                  {{ period.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div>
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'frequency' | translate }}</mat-label>

          <input
            matInput
            agrNumber
            formControlName="frequency"
            [placeholder]="'frequency' | translate"
            [step]="1"
            data-test="treatment-frequency"
            autocomplete="off"
          />
        </mat-form-field>
      </div>

      <div class="flex--row flex--gutter">
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'moment' | translate }}</mat-label>

          <textarea
            matInput
            [placeholder]="'moment' | translate"
            formControlName="moment"
            [cdkTextareaAutosize]="true"
            [cdkAutosizeMinRows]="3"
            data-test="editTreatment-moment"
          ></textarea>
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'pointOfAttention' | translate }}</mat-label>

          <textarea
            matInput
            [placeholder]="'pointOfAttention' | translate"
            formControlName="pointOfAttention"
            [cdkTextareaAutosize]="true"
            [cdkAutosizeMinRows]="3"
            data-test="treatment-point-of-attention"
          ></textarea>
        </mat-form-field>
      </div>

      @if (templateType === 'GBM') {
        <div class="flex--row flex--gutter">
          <mat-form-field class="full-width-field">
            <mat-label>{{ 'driftReduction' | translate }}</mat-label>
            <mat-select
              formControlName="driftReduction"
              [placeholder]="'driftReduction' | translate"
              data-test="editTreatment-driftReduction"
            >
              @for (percentage of driftReductions; track percentage) {
                <mat-option [value]="percentage"> {{ percentage }}%</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }

      @if (!everyAidAdviceValid()) {
        <div class="notification notification-error">
          <mat-icon>error</mat-icon>
          {{ 'invalidAidAdvices' | translate }}
        </div>
      }
    </div>
    @if (!addingProduct) {
      <button
        mat-flat-button
        type="button"
        color="primary"
        (click)="addProduct()"
        [disabled]="!!editedProduct || editedProduct === 0"
        data-test="treatment-add-product"
      >
        <mat-icon>add</mat-icon>
        {{ 'addCropAid' | translate }}
      </button>
    }

    @if (addingProduct) {
      <ng-container formArrayName="aidAdvices">
        <div
          class="flex--container"
          [formGroupName]="aidAdvicesFormArray.length - 1"
          data-test="treatment-productForm"
        >
          <div class="flex--row flex--gutter">
            <div class="flex__child flex__child-3">
              <mat-form-field class="full-width-field spacing--margin-half-top">
                <mat-label>{{ 'product' | translate }}</mat-label>
                <input
                  type="text"
                  [placeholder]="'product' | translate"
                  matInput
                  formControlName="cropAidId"
                  [matAutocomplete]="newProductAutocomplete"
                  #newProductInput
                  data-test="editTreatment-productFilter"
                  (blur)="checkProduct()"
                />
                <mat-autocomplete
                  #newProductAutocomplete="matAutocomplete"
                  (optionSelected)="selectProduct($event.option.value, true)"
                  [displayWith]="displayProduct()"
                >
                  @for (option of filteredProducts$ | async; track option) {
                    <mat-option [value]="option.id" data-test="editTreatment-productOption">
                      {{ option.name }}
                      {{ getAdmissionNumberString(option.cropProtection?.admissions) }}
                    </mat-option>
                  }
                </mat-autocomplete>
                @if (!isCropAidValid(selectedProduct)) {
                  <p class="notification notification-error">
                    <mat-icon>warning</mat-icon>{{ 'cropAidForbiddenInPlanetProof' | translate }}
                  </p>
                }
              </mat-form-field>
            </div>
            <div class="flex__child">
              <mat-form-field class="full-width-field spacing--margin-half-top">
                <mat-label>
                  {{ 'dosage' | translate }}
                  {{ selectedProduct ? ' (' + selectedProduct.unitOfMeasurement + ')' : '' }}
                </mat-label>
                <input
                  matInput
                  agrNumber
                  [placeholder]="
                    ('dosage' | translate) +
                    (selectedProduct ? ' (' + selectedProduct.unitOfMeasurement + ')' : '')
                  "
                  formControlName="dosage"
                  data-test="editTreatment-productDosage"
                  [step]="0.001"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          </div>
          <app-legal-restriction-info
            [cropAid]="selectedProduct"
            [cropId]="cropId"
          ></app-legal-restriction-info>
          <div class="flex--row flex--gutter flex--justify-end spacing--margin-bottom">
            <div class="flex__child--none">
              <button mat-flat-button (click)="cancelAddingProduct()">
                {{ 'cancel' | translate }}
              </button>
              <button
                mat-flat-button
                color="primary"
                (click)="doneAddingProduct()"
                [disabled]="aidAdvicesFormArray.invalid"
                data-test="done-adding-product"
              >
                {{ 'add' | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    }
    @if (cropAidAdvices.length) {
      <mat-list
        data-test="editTreatment-products"
        class="layout--margin-negative-horizontal spacing--margin-bottom"
        formArrayName="aidAdvices"
      >
        @for (cropAidAdvice of cropAidAdvices; track cropAidAdvice; let i = $index) {
          <ng-container [formGroupName]="i">
            @for (
              selectedCropAid of [findProduct(aidAdvicesFormArray.at(i).get('cropAidId').value)];
              track selectedCropAid
            ) {
              @if (editedProduct !== i) {
                <mat-list-item class="align-item-center" data-test="editTreatment-productRow">
                  @if (isCropAidValid(selectedCropAid)) {
                    <mat-icon matListItemIcon>receipt</mat-icon>
                  }
                  @if (!isCropAidValid(selectedCropAid)) {
                    <mat-icon matListItemIcon color="warn">error</mat-icon>
                  }
                  <h2 matListItemTitle>
                    {{ selectedCropAid.name }}
                    {{ getAdmissionNumberString(selectedCropAid.cropProtection?.admissions) }}
                  </h2>
                  <span matListItemLine>
                    {{ selectedCropAid.cropProtection?.activeIngredient }}
                    {{ getIndicativePrice(selectedCropAid.indicativePrice) | agrCurrency: 'EUR' }}
                  </span>
                  @if (!isCropAidValid(selectedCropAid)) {
                    <span
                      matListItemLine
                      class="text-color--warn-500 background-color--warn-50 spacing--padding-half-left spacing--padding-half-right"
                    >
                      {{ 'cropAidForbiddenInPlanetProof' | translate }}
                    </span>
                  }
                  <span matListItemLine>
                    {{ aidAdvicesFormArray.at(i).get('dosage').value | agrNumber }}
                    {{ selectedCropAid ? selectedCropAid.unitOfMeasurement : '' }}
                  </span>
                  <div matListItemMeta>
                    <ng-container>
                      <button
                        mat-icon-button
                        type="button"
                        (click)="editProduct(i)"
                        [disabled]="addingProduct || (editedProduct && editedProduct !== i)"
                        data-test="editTreatment-editProduct"
                      >
                        <mat-icon class="text-color--black">edit</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        type="button"
                        (click)="removeProduct(i)"
                        [disabled]="addingProduct || (editedProduct && editedProduct !== i)"
                        data-test="editTreatment-removeProduct"
                      >
                        <mat-icon class="text-color--black">delete</mat-icon>
                      </button>
                    </ng-container>
                  </div>
                </mat-list-item>
              }
              @if (editedProduct === i) {
                <div class="layout--margin-horizontal spacing--margin-top">
                  <div class="flex--row flex--gutter" data-test="editTreatment-editForm">
                    <div class="flex__child flex__child-3">
                      <mat-form-field class="full-width-field">
                        <mat-label>{{ 'product' | translate }}</mat-label>
                        <input
                          type="text"
                          [placeholder]="'product' | translate"
                          matInput
                          formControlName="cropAidId"
                          [matAutocomplete]="editProductAutocomplete"
                          #newProductInput
                          data-test="editTreatment-productFilter"
                          (blur)="checkProduct()"
                        />
                        <mat-autocomplete
                          #editProductAutocomplete="matAutocomplete"
                          (optionSelected)="selectProduct($event.option.value)"
                          [displayWith]="displayProduct()"
                        >
                          @for (option of filteredProducts$ | async; track option) {
                            <mat-option [value]="option.id" data-test="editTreatment-productOption">
                              {{ option.name }}
                              {{ getAdmissionNumberString(option.cropProtection?.admissions) }}
                            </mat-option>
                          }
                        </mat-autocomplete>
                        @if (!isCropAidValid(selectedCropAid)) {
                          <p class="notification notification-error">
                            <mat-icon>warning</mat-icon
                            >{{ 'cropAidForbiddenInPlanetProof' | translate }}
                          </p>
                        }
                      </mat-form-field>
                    </div>
                    <div class="flex__child">
                      <mat-form-field class="full-width-field">
                        <mat-label>
                          {{ 'dosage' | translate }}
                          {{ selectedCropAid ? '(' + selectedCropAid.unitOfMeasurement + ')' : '' }}
                        </mat-label>
                        <input
                          matInput
                          agrNumber
                          [placeholder]="
                            ('dosage' | translate) + ' (' + selectedCropAid?.unitOfMeasurement + ')'
                          "
                          formControlName="dosage"
                          data-test="editTreatment-productDosage"
                          [step]="0.001"
                          autocomplete="off"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              }
            }
            @if (editedProduct === i) {
              <div class="layout--margin-horizontal">
                <div class="flex--row flex--gutter flex--justify-end spacing--margin-bottom">
                  <div class="flex__child--none">
                    <button
                      mat-flat-button
                      type="button"
                      color="primary"
                      (click)="doneEditingProduct()"
                      [disabled]="aidAdvicesFormArray.invalid"
                      data-test="done-adding-product"
                    >
                      {{ 'ok' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            }
            <app-legal-restriction-info
              [cropAid]="cropAidAdvice"
              [cropId]="cropId"
            ></app-legal-restriction-info>
          </ng-container>
        }
      </mat-list>
    }
  </div>
</agr-form-dialog>
